// ABOUTME: Swaps the jf-nutrition-panel block body when the selected variant changes.
// Same-product variant changes morph only the variant picker, so this element listens for the
// section's StandardEvents.productSelect and lifts its replacement out of the event promise's
// fetched document (the product-price.js pattern), which the server rendered with the new
// variant's accordion_w_image_upload override -> product fallback chain already applied.
import { StandardEvents } from '@shopify/events';

class JfNutritionPanel extends HTMLElement {
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
    this.#section = null;
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.newProduct) return; // combined listing loads morph <main> wholesale
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const next = detail.html.querySelector(`jf-nutrition-panel[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        this.className = next.className; // --empty visibility follows the new variant
        this.replaceChildren(...next.cloneNode(true).childNodes);
      })
      .catch(() => {});
  };
}

if (!customElements.get('jf-nutrition-panel')) {
  customElements.define('jf-nutrition-panel', JfNutritionPanel);
}
